import styled from "styled-components";

export default styled.div `
  
    position: relative;
    
    .disableEditor {
        position: absolute;
        z-index: 10;
        background-color: rgba(0, 0, 0, 0.3);
        width: 100%;
        height: 100%;
        border-radius: 2px;
        padding: 20px;
        
    }
  
`;
